/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Clips_TitleInputs */

const en_road_dude_clips_title = /** @type {(inputs: Road_Dude_Clips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same stare. New driver.`)
};

const zh_road_dude_clips_title = /** @type {(inputs: Road_Dude_Clips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还是那个眼神，换了位司机。`)
};

/**
* | output |
* | --- |
* | "Same stare. New driver." |
*
* @param {Road_Dude_Clips_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_clips_title = /** @type {((inputs?: Road_Dude_Clips_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Clips_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_clips_title(inputs)
	return zh_road_dude_clips_title(inputs)
});
export { road_dude_clips_title as "road_dude.clips.title" }